import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuietTime = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1262 233Q1208 224 1152 224Q970 224 815.0 314.0Q660 404 570.0 559.0Q480 714 480 896Q480 1088 584 1253Q383 1193 255.5 1024.0Q128 855 128 640Q128 510 179.0 391.5Q230 273 315.5 187.5Q401 102 519.5 51.0Q638 0 768 0Q912 0 1041.5 61.5Q1171 123 1262 233ZM1465 318Q1371 115 1181.5 -6.5Q992 -128 768 -128Q612 -128 470.0 -67.0Q328 -6 225.0 97.0Q122 200 61.0 342.0Q0 484 0 640Q0 793 57.5 932.5Q115 1072 213.5 1174.0Q312 1276 449.0 1338.5Q586 1401 739 1407Q783 1409 800 1368Q818 1327 785 1296Q699 1218 653.5 1114.5Q608 1011 608 896Q608 748 681.0 623.0Q754 498 879.0 425.0Q1004 352 1152 352Q1270 352 1380 403Q1421 421 1452 390Q1466 376 1469.5 356.0Q1473 336 1465 318Z"
	})
});
export default SvgQuietTime;
